import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21161f67"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("音声"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "おんせい"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("が"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("再生"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "さいせい"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("できませんでした")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("もう"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("一度"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "いちど"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("再生"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "さいせい"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("するには、「"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("再生"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "さいせい"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("」ボタンをクリックしてください。")
], -1))
const _hoisted_3 = { class: "button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("再生"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "さいせい"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "modal-backdrop",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
    }, [
      _createElementVNode("div", {
        class: "modal",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "button-play",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
          }, [
            _hoisted_4,
            _createTextVNode("する")
          ]),
          _createElementVNode("button", {
            class: "button-cancel",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, "キャンセル")
        ])
      ])
    ])
  ]))
}